interface StorageLike {
  setItem: (key: string, value: string) => void;
  removeItem: (key: string) => void;
}

const getBrowserLocalStorage = (): StorageLike | undefined => {
  try {
    return typeof localStorage === "undefined" ? undefined : localStorage;
  } catch {
    return undefined;
  }
};

export const safeSetLocalStorageItem = (
  key: string,
  value: string,
  storage: StorageLike | undefined = getBrowserLocalStorage(),
) => {
  if (!storage) return;

  try {
    storage.setItem(key, value);
  } catch {
    // Filters remain usable in memory when browser storage is unavailable.
  }
};

export const safeRemoveLocalStorageItem = (
  key: string,
  storage: StorageLike | undefined = getBrowserLocalStorage(),
) => {
  if (!storage) return;

  try {
    storage.removeItem(key);
  } catch {
    // Ignore storage availability and quota errors.
  }
};
